<template>
    <el-carousel
        v-if="permissionsShow"
        :height="height"
        :initial-index="initialIndex"
        :trigger="trigger"
        :autoplay="autoplay"
        :interval="interval"
        :indicator-position="indicatorPosition"
        :arrow="arrow"
        :type="type"
        ref="carouselRef"
        :loop="loop"
        @change="_change"
    >
        <el-carousel-item v-for="(item, index) in listInfo" :key="index">
            <div v-if="item.src != undefined">
                <img :src="item.src" alt="" :width="item.width" :height="item.height" />
            </div>
            <h3 v-else>{{ item }}</h3>
        </el-carousel-item>
    </el-carousel>
</template>
<script>
export default {
    props: {
        listInfo: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 高度，无默认值 */
        height: String,
        /* 初始状态激活的幻灯片的索引，从 0 开始 */
        initialIndex: {
            type: Number,
            default: 0
        },
        /* 指示器的触发方式,可选值 click */
        trigger: {
            type: String,
            default: 'hover'
        },
        /* 是否自动切换 */
        autoplay: {
            type: Boolean,
            default: true
        },
        /* 自动切换的时间间隔，单位为毫秒 */
        interval: {
            type: Number,
            default: 3000
        },
        /* 指示器的位置outside/none */
        indicatorPosition: String,
        /* 切换箭头的显示时机 可选值always/hover/never */
        arrow: {
            type: String,
            default: 'hover'
        },
        /* 走马灯的类型 可选值card */
        type: String,
        /* 是否循环显示 */
        loop: {
            type: Boolean,
            default: true
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    watch: {
        /* 监听主体信息变化 */
        listInfo: {
            handler: function(newVal) {
                this.listInfo = newVal;
            },
            deep: true
        }
    },
    created() {
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
    },
    methods: {
        /* 卡片切换时触发的事件 ,进行父组件事件回调 */
        _change(currentIndex, OldIndex) {
            this.$emit('change', currentIndex, OldIndex);
        },
        /* 手动切换幻灯片 */
        setActiveItem(index) {
            this.$refs.carouselRef.setActiveItem(index);
        },
        /* 切换至上一张幻灯片 */
        prev() {
            this.$refs.carouselRef.prev();
        },
        /* 切换至下一张幻灯片 */
        next() {
            this.$refs.carouselRef.next();
        }
    }
};
</script>
<style>
.el-carousel__indicators--outside button {
    background-color: rgb(30, 160, 255);
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
    text-align: center;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}
img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}
</style>
